import React, { Component } from 'react';
import { Header, Divider, Grid, Button, Form, } from 'semantic-ui-react'
import axios from 'axios'
import * as UiConsts from '../../../../config/UiConstants'
import { serverIp, firebaseAuth, logComponentLoad } from '../../../../config/constants.js'
import createBrowserHistory from 'history/createBrowserHistory';
import { getLargeProjectItem, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import LargeProjectOrderEntry_options from './LargeProjectOrderEntry_options';
import ViewProject_header from './ViewProject_header';
import LargeProjectOrderEntry_measurements from './LargeProjectOrderEntry_measurements';
const history = createBrowserHistory({ forceRefresh: true });

export default class LargeProjectOrderEntry extends Component {
    constructor(props) {
        super(props)

        this.state = ({
            loading: true,
            finalCardOrder: [],
            large_project_object: '',
            optionsArray: [],
            checkOptionsArray: [],
            measurementsArray: [],
            large_project_measurements: ''
        })
    }

    componentDidMount() {

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })


    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        //console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        if (returnObject.algoliaUser.perms.includes("largeProjectOrderEntry")) {
            logComponentLoad(returnObject, "LargeProjectOrderEntry");

            if (this.props.match.params.projectId) {
                console.log("projectId:" + this.props.match.params.projectId);

                //1. GET MAIN CARD OBJECTS FROM ALGOLIA
                getLargeProjectItem("large_project_objects", this.props.match.params.item, this.setMainCardObjects);
                getLargeProjectItem("large_project_objects", "large_project_measurements", this.setMeasurements);
            } else {
                alert("no probject id sent, pls double check url")
            }
        } else {
            logComponentLoad(returnObject, "FAILED - LargeProjectOrderEntry");
        }

    }

    setCheckOptionsArray = (optionsArray) => {
        console.log("chx1 ++++++ setCheckOptionsArray +++++++");
        console.log("chx12 checkOptionsArray array:" + JSON.stringify(this.state.optionsArray, null, 3));

        let tempArray = [];

        optionsArray.forEach(val => {
            console.log('chx13 adding item:' + val.option_name);
            tempArray.push(val.option_name)
        });

        this.setState({
            checkOptionsArray: tempArray
        })

        console.log("chx13 tempArrayarray:" + JSON.stringify(tempArray, null, 3));

    }

    //2. SET MAIN CARD OBJECTS
    setMainCardObjects = (objects) => {
        console.log("obx1 +++++++:setMainCardObjects");
        console.log("obx12 hits:" + JSON.stringify(objects, null, 3));

        this.setState({
            loading: false
        })

        if (objects.length > 0) {
            console.log("object is there...");

            this.setState({
                large_project_object: objects[0],
                checkOptionsArray: objects[0].options
            })

            this.setCheckOptionsArray(objects[0].options)
        }

    }

    setMeasurements = (objects) => {
        console.log("mobx1 +++++++:setMeasurements");
        console.log("mobx12 hits:" + JSON.stringify(objects, null, 3));

        this.setState({
            loading: false
        })

        if (objects.length > 0) {
            console.log("object is there...");

            this.setState({
                large_project_measurements: objects[0]
            })
        } else {
            alert("unable to get measurements");
        }

    }

    handleLargeProjectEntryDropDownChanges = (value) => {
        console.log('value:', JSON.stringify(value, null, 3));
        console.log('details:', value.value + " " + value.category);

        let temp_optionsArray = this.state.optionsArray;
        console.log('initial Array:' + JSON.stringify(temp_optionsArray, null, 3));

        //CHECK IF EXISTS
        let foundIndex = temp_optionsArray.findIndex(x => x.category == value.category);
        console.log("foundIndex:" + foundIndex);

        if (foundIndex != -1) {
            console.log("foundIndex != -1, item is there:" + value.category);
            temp_optionsArray[foundIndex] = value;

            console.log("item:" + value.category + " updated now array is:" + JSON.stringify(temp_optionsArray, null, 3));
        } else {
            console.log("item:" + value.category + " not found adding to array");
            temp_optionsArray.push(value);
            console.log("options array:" + JSON.stringify(temp_optionsArray, null, 3));
        }

        let newState = {};
        newState['optionsArray'] = temp_optionsArray;
        console.log('final Array:' + JSON.stringify(temp_optionsArray, null, 3));
        this.setState(newState);
    }

    handleTextInputChange = (e) => {
        console.log("mx1 >>>>: handleTextInputChange ");
        console.log("mx33 e.target.type:" + e.target.type);
        console.log("mx32 e.target.name:" + e.target.name);
        console.log("mx34 e.target.value:" + e.target.value);

        let mObject = {};
        mObject.measurement_name = e.target.name;
        mObject.measurement_value = e.target.value;
        console.log('mObject:' + JSON.stringify(mObject, null, 3));

        let temp_measurementsArray = this.state.measurementsArray;
        console.log('initial Array:' + JSON.stringify(temp_measurementsArray, null, 3));

        //CHECK IF EXISTS
        let foundIndex = temp_measurementsArray.findIndex(x => x.measurement_name == mObject.measurement_name);
        console.log("foundIndex:" + foundIndex);

        if (foundIndex != -1) {
            console.log("foundIndex != -1, item is there:" + mObject.measurement_name);
            temp_measurementsArray[foundIndex] = mObject;

            console.log("item:" + mObject.measurement_name + " updated now array is:" + JSON.stringify(temp_measurementsArray, null, 3));
        } else {
            console.log("item:" + mObject.measurement_name + " not found adding to array");

            temp_measurementsArray.push(mObject);
            console.log("options array:" + JSON.stringify(temp_measurementsArray, null, 3));
        }

        let newState = {};
        newState['measurementsArray'] = temp_measurementsArray;
        console.log('final temp_measurementsArray Array:' + JSON.stringify(temp_measurementsArray, null, 3));
        this.setState(newState);

    }

    handleChange = (e) => {
        console.log("hx1 >>>>: handleChange clicked");
        console.log("hx12 e.target.type:" + e.target.type);
        console.log("hx13 e.target.name:" + e.target.name);
        console.log("hx14 e.target.value:" + e.target.value);

        let newState = {};
        newState[e.target.name] = e.target.value;
        this.setState(newState);

    }

    checkItems = () => {
        console.log("++++++ checkItems ++++++");
        console.log("chx12 checkOptionsArray array:" + JSON.stringify(this.state.checkOptionsArray, null, 3));

        let okToProceed = false;

        for (let i = 0; i < this.state.checkOptionsArray.length; i++) {
            let val = this.state.checkOptionsArray[i];
            console.log("chx13 checking:" + this.state.checkOptionsArray[i]);

            //CHECK IF EXISTS
            let foundIndex = this.state.optionsArray.findIndex(x => x.category == this.state.checkOptionsArray[i]);
            console.log("chx14 foundIndex:" + foundIndex);

            if (foundIndex != -1) {
                console.log("foundIndex != -1, item is there:" + this.state.checkOptionsArray[i]);
                okToProceed = true;
            } else {
                console.log("item:" + this.state.checkOptionsArray[i] + " not found adding to array");
                okToProceed = false;
                alert("Please enter value for "+this.state.checkOptionsArray[i])
                break;
                
            }
        }

        if(okToProceed){
            console.log("ok to proceed");
            this.sendItems();
        }
    }

    sendItems = () => {
        console.log("++++++ sendItems ++++++");

        if (!this.state.item_name) {

            alert("Please enter a name")

        }else if (this.state.measurementsArray.length == 0) {

            alert("Please enter measurements")

        }  else {

            

            this.setState({ loading: true })

            axios.post(serverIp + "large_project_items/saveLargeProjectItems", {
                apiKey: "APODFASF@dDFDD",
                enteredBy: this.state.user.email,
                projectId: this.props.match.params.projectId,
                shirtType: this.props.match.params.item,
                itemOptions: this.state.optionsArray,
                measurements: this.state.measurementsArray,
                item_name: this.state.item_name
            })
                .then((response) => {

                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. ");

                        this.setState({
                            loading: false,
                            largeProject_item_models: response.data.largeProject_item_models
                        })

                        //alert(response.data.message);
                        history.push("/dashboard/viewLargeProjectItems/" + this.props.match.params.projectId);
                    } else {
                        console.log("FAILED");
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }



    }

    render() {

        const optionsArray = this.state.large_project_object != ''
            ? this.state.large_project_object.options.map((option) =>
                <Grid.Column>
                    <LargeProjectOrderEntry_options
                        option={option}
                        handleLargeProjectEntryDropDownChanges={this.handleLargeProjectEntryDropDownChanges} />
                </Grid.Column>
            )
            : ''

        const measurementsArray = this.state.large_project_measurements != ''
            ? this.state.large_project_measurements.measurements.map((measurement) =>
                <Grid.Column>
                    <LargeProjectOrderEntry_measurements
                        measurement={measurement}
                        handleTextInputChange={this.handleTextInputChange} />
                </Grid.Column>
            )
            : ''

        return (this.state.loading === true ? <UiConsts.LoadingComponent /> :
            <div>
                {/* CLOSURE */}
                {/* <Image centered src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/closureNotices%2FPrintboda%20-%20covid%20-%20closed_5_siteImage-min.jpg?alt=media&token=432231de-4ede-40dc-a04d-701aa9e58cfa' /> */}

                <ViewProject_header projectId={this.props.match.params.projectId} user={this.state.user} />

                <Grid container>
                    <Grid.Column >
                        <Form size='large' onSubmit={this.handleSubmit}>

                            <Header
                                as='h3'
                                content={this.props.match.params.item}
                                textAlign='center'
                                subheader={this.props.match.params.item}
                            />

                            <Divider horizontal>{'NAME'}</Divider>

                            <Form.Field>
                                <label>Name</label>
                                <Form.Input
                                    fluid
                                    icon='person'
                                    iconPosition='left'
                                    placeholder='Name'
                                    type='text'
                                    name='item_name'
                                    onChange={this.handleChange}
                                />
                            </Form.Field>

                        </Form>
                    </Grid.Column>
                </Grid>


                <Divider horizontal>{'ITEM OPTIONS'}</Divider>
                <Grid container stackable columns={2}>
                    {optionsArray}
                </Grid>

                <Divider horizontal>{'MEASUREMENTS'}</Divider>
                <Grid container stackable columns={4}>
                    {measurementsArray}
                </Grid>

                <br />
                <Button fluid color='green' onClick={this.checkItems} > SEND ITEM </Button>

            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/LargeProjectOrderEntry.js